import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

import type { ServicoGeralRequest, ServicoGeralResponse } from './servico-geral.model';

@Injectable({ providedIn: 'root' })
export class ServicoGeralService extends BaseService {
    readonly PATH = SICOM_PATHS.servicos.gerais;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(params: ServicoGeralRequest, context?: HttpContext): Observable<ServicoGeralResponse[]> {
        const httpParams = new HttpParams().set('uf_crm', params.ufCrm);
        return this.http.get<ServicoGeralResponse[]>(this.PATH, { params: httpParams, context });
    }
}
